import axios from '@/axios';
import HandleResponses from '@common/utils/handleResponses';

const actions = {
  async tripCreate({ commit }, { data }) {
    commit('TRACK_FORM_LOAD', true);
    try {
      const result = await axios.post('transporter/trip', { data });
      if (result && result.data) {
        commit('APPEND_NEW_TRIP', { data: result.data });
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('TRACK_FORM_LOAD', false);
    }
  },
  async tracklist({ commit }, { params }) {
    try {
      if (params.page === 1) {
        commit('SET_TRIP_LOADING_LIST_STATUS', true);
      } else {
        commit('SET_TRIP_PAGINATION', true);
      }
      const result = await axios('transporter/trip', { params });
      commit('SET_TRIP_ALL', result.data);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('SET_TRIP_LOADING_LIST_STATUS', false);
      commit('SET_TRIP_PAGINATION', false);
    }
  },
  async getTrackMeta({ commit }) {
    try {
      const result = await axios('transporter/trip/getMetadata');
      if (result.data) {
        commit('SET_TRACK_META', result.data);
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async show({ commit }, { id }) {
    try {
      commit('SET_TRIP_SHOW_LOADING', true);
      const result = await axios(`/transporter/trip/${id}/locations`);
      commit('TRIP_DETAILS', { data: result.data });
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('SET_TRIP_SHOW_LOADING', false);
    }
  },
  async endTrip({ commit }, { id }) {
    commit('SET_TRIP_FORM_LOADING', true);
    try {
      const result = await axios.put(`/transporter/trip/${id}/endTrip`, { data: [] });
      if (result && result.data) {
        commit('UPDATE_EXISTING', { data: result.data });
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('SET_TRIP_FORM_LOADING', false);
    }
  },
};

export default actions;
